import * as tslib_1 from "tslib";
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { ReverseRelevanceControl } from "../../../../../../form/src/common/controls/reverse-relevance-control";
import { ReverseQueryService } from "../../../../../../form/src/common/services";
import { Component } from "vue-property-decorator";
let ReverseRelevanceList = class ReverseRelevanceList extends ReverseRelevanceControl {
    constructor() {
        super(...arguments);
        this.queryCondition = {};
    }
    created() {
        const comp = RelevanceFormControl.loadListSelector();
        this.$options.components.ListSelector = comp;
        const conditions = this.controlOpts.conditions;
        const formControls = this.getFormControls();
        const c = this.control;
        this.queryCondition = ReverseQueryService.getParams(conditions, formControls, c, this.findController);
        this.queryCondition.push(this.field);
    }
    // get query() {
    //   const conditions = this.controlOpts.conditions;
    //   const formControls = this.getFormControls();
    //   const c =  this.control;
    //   const param = ReverseQueryService.getParams(conditions,formControls,c, this.findController);
    //   return {}
    // }
    get defaultQuery() {
        const val = [];
        if (this.field) {
            const { code, type, value } = this.field;
            val.push({
                propertyCode: code,
                propertyType: type,
                propertyValue: value
            });
        }
        return val;
    }
};
ReverseRelevanceList = tslib_1.__decorate([
    Component({
        name: "reverse-relevance-list",
        components: {}
    })
], ReverseRelevanceList);
export default ReverseRelevanceList;
